import { render, staticRenderFns } from "./CeoBonuses.vue?vue&type=template&id=2bab9254&"
import script from "./CeoBonuses.vue?vue&type=script&lang=js&"
export * from "./CeoBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports